import React, { useEffect, useRef, useState } from "react"
import Select from 'react-select';
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import Input from "../../components/utils/Input";
import { addOtherExpenditure } from "../../action/cassa";
import { roleId } from "../../constants/app";
import moment from "moment";

const optionsTypeTransaction = [
    {label: 'Наличные', value: 'cash'},
    {label: 'Безнал.', value: 'noncash'}
];

const OtherExpendituresAddArticles = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const articlesExpenditures = useSelector(state => state.handbook.articlesExpenditures);
    const user = useSelector(state => state.user.info)

    const [article, setArticle] = useState({
        visible_datetime: null,
        articleId: null,
        name: null,
        sum: null,
        typeTransaction: null,
        author: null,
        payment: 'unpaid',
        point: null,
        comment: null
    });
    const [availableArticles, setAvailableArticles] = useState(null);

    useEffect(() => {
        const userRole = user.role.id;
        let filteredArticles = articlesExpenditures;
        if(userRole === roleId.manager) {
            filteredArticles = articlesExpenditures.filter(item => item.typeTransaction === 'cash' || item.typeTransaction === 'all');
            setDataArticle('typeTransaction')({value: 'cash'});
        }

        if(userRole === roleId.accountant || userRole === roleId.chiefAccountant) {
            filteredArticles = articlesExpenditures.filter(item => item.typeTransaction === 'noncash' || item.typeTransaction === 'all');
            setDataArticle('typeTransaction')({value: 'noncash'});
        }
        setAvailableArticles(filteredArticles.map(item => ({ label: item.name, value: item.id })));
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        const userRole = user.role.id;
        let filteredArticles = articlesExpenditures;
        if(userRole === roleId.manager) {
            setDataArticle('typeTransaction')({value: 'cash'});
        }

        if(userRole === roleId.accountant || userRole === roleId.chiefAccountant) {
            setDataArticle('typeTransaction')({value: 'noncash'});
        }

        if(article.typeTransaction) {
            filteredArticles = articlesExpenditures.filter(item => item.typeTransaction === article.typeTransaction || item.typeTransaction === 'all');
        }
        setAvailableArticles(filteredArticles.map(item => ({ label: item.name, value: item.id })));        
        // eslint-disable-next-line
    }, [article.typeTransaction]);

    const onClose = () => dispatch(setActiveModalAction({ field: 'otherExpendituresAddArticles', value: null }));
    
    useOnClickOutside(ref, onClose);

    const onSubmit = () => {
        const data = {...article};

        if(MinDate() && data.visible_datetime < MinDate()) {
            data.visible_datetime = MinDate();
        }

        dispatch(addOtherExpenditure(data));

        onClose();
    }

    const isValidArticle = () => {
        if(!article.sum || !article.name || !article.articleId || !article.typeTransaction || !article.visible_datetime) 
            return false;
        return true;
    }

    const setDataArticle = (field) => (e) => {
        const data = {...article};

        if(field === 'visible_datetime' && MinDate() && e.target.value < MinDate()) {
            e.target.value = MinDate();
        }

        if (field === 'articleId') {
            data.articleId = e.value;
            data.name = e.label;
        } else if(field === 'typeTransaction' || field === 'name') {
            data[field] = e.value;
        } else {
            data[field] = e.target.value;            
        }

        setArticle(data);
    }

    const MinDate = () => {
        // const date = moment()
        if(![roleId.admin, roleId.chiefCommoditySpecialist].includes(user.role.id)) {
            // if(parseInt(date.date()) > 15) return date.startOf('month').format('YYYY-MM-DDTHH:mm');
            return moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DDTHH:mm');
        }
        return null;
    }

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div ref={ref} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"> Расход </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Дата *</div>
                                <input
                                className="form-control"
                                placeholder="Дата"
                                type="datetime-local"
                                onChange={setDataArticle('visible_datetime')}
                                defaultValue={article.visible_datetime}
                                min={MinDate()}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Тип *</div>                               
                                <Select
                                    isDisabled={[roleId.manager, roleId.accountant, roleId.chiefAccountant].includes(user.role.id)}
                                    placeholder='Тип'
                                    value={optionsTypeTransaction.find((el) => el.value === article.typeTransaction)}
                                    onChange={setDataArticle('typeTransaction')}
                                    options={optionsTypeTransaction}
                                    noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Статья *</div>                               
                                <Select
                                    isDisabled={!article.typeTransaction}
                                    placeholder='Статья'
                                    value={article.articleId ? {value: article.id, label: article.name} : ''}
                                    onChange={setDataArticle('articleId')}
                                    options={availableArticles}
                                    noOptionsMessage={() => 'Нет статей'}
                                />
                            </div>
                            <Input
                            label='Сумма'
                            type="number"
                            required={true}
                            onChange={setDataArticle('sum')}
                            value={article.sum}
                            placeholder='Сумма'
                            />
                            <Input
                            textarea={true}
                            label='Примечание'
                            onChange={setDataArticle('comment')}
                            value={article.comment}
                            placeholder='Примечание'
                            />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                            <button disabled={!isValidArticle()} type="button" onClick={onSubmit} className='btn btn-primary'>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(OtherExpendituresAddArticles);